var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 19,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.498.66C8.083.042 8.975.042 9.56.66c.585.618.585 1.559 0 2.177l-6.027 6.36 6.027 6.36a1.568 1.568 0 0 1 0 2.176 1.52 1.52 0 0 1-.456.344c-.176.082-.365.12-.576.12-.21 0-.4-.038-.575-.12a1.52 1.52 0 0 1-.456-.344L.439 10.285a1.569 1.569 0 0 1 0-2.177L7.498.66Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron_left.f00d673b6db7c66eec2d21be453661cb.svg";
export { ForwardRef as ReactComponent };